import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { Visibility,VisibilityOff} from '@material-ui/icons/';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { API } from "aws-amplify";

const User = () => {
    const [overlay, setOverlay] = useState(true);
    const [page, setPage] = useState(1);
    const [sellers, setSellers] = useState([]);
    const [totalSellers, setTotalSellers] = useState(0);
    const [passwordDialog, setPasswordDialog] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [targetSeller, setTargetSeller] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [sellersPerPage, setSellersPerPage] = useState(50);
    const [nextTokens, setNextTokens] = useState({ 1: null });
    const [nextToken, setNextToken] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(100);

    const totalPages = Math.ceil(totalItems/ sellersPerPage);
    
    useEffect(() => {
        if (nextToken) {
            fetchData(nextToken);
        }
    }, [nextToken]); 
    
    useEffect(() => {
        fetchTotalSellers(); // 初回ロード時に全データ件数を取得
    }, []);
    

    useEffect(() => {
        listSellers(page, sellersPerPage);
    }, [page, sellersPerPage]);
    
    const fetchData = async (nextToken) => {
        const response = await fetch(`/api/data?nextToken=${nextToken}`);
        const result = await response.json();

        if (result.nextToken) {
            setNextToken(result.nextToken);
        }
    };

    const fetchTotalSellers = async () => {
        let total = 0;
        let nextToken = null;

        try {
            do {
                const getTotalSellersQuery = `
                query ListSellers($limit: Int, $nextToken: String) {
                    listSellers(limit: $limit, nextToken: $nextToken) {
                        items {
                            id
                        }
                        nextToken
                    }
                }`;

            const variables = { limit: 100, nextToken }; // 1回のリクエストで最大100件取得
            const response = await API.graphql({ 
                query: getTotalSellersQuery, 
                variables, 
                authMode: 'AMAZON_COGNITO_USER_POOLS',
            });

            const listData = response.data.listSellers;
            total += listData.items.length; // 件数を加算
            nextToken = listData.nextToken || null; // 次のページがあれば取得

        } while (nextToken); // nextToken がある間はリクエストを続ける

        setTotalSellers(total); // 総件数を保存
    } catch (error) {
        console.error("Error fetching total sellers:", error);
        setTotalSellers(0);
    }
};
    

    const listSellers = async (pageParam = 1, limit = sellersPerPage) => {
        const getListSellers = `
        query ListSellers($limit: Int, $nextToken: String) {
            listSellers(limit: $limit, nextToken: $nextToken) {
                items {
                    id
                    name
                    email
                    phone
                    postal
                    address
                    stripeID
                    createdAt
                }
                nextToken
            }
        }
        `;
    
        const variables = {
            limit,
            nextToken:  nextTokens[pageParam] || null,
        };

        try {
            setOverlay(true);
            const response = await API.graphql({
                query: getListSellers,
                variables,
                authMode: 'AMAZON_COGNITO_USER_POOLS',
            });
            const listData = response.data.listSellers;

            if (listData && listData.items) {
                
                setSellers(listData.items); // データをセット
                setSellers((prevSellers) => {
                    const newSellers = listData.items.filter(
                        (seller) => !prevSellers.some((prev) => prev.id === seller.id)
                    );
                    return pageParam === 1 ? listData.items : [...prevSellers, ...newSellers];
                });

                setTotalSellers((prevTotal) =>
                    pageParam === 1 ? listData.items.length : prevTotal
                );


                setNextTokens((prevTokens) => ({
                    ...prevTokens,
                    [pageParam]: prevTokens[pageParam] || null,  // 現在のページのnextTokenを維持
                    [pageParam + 1]: listData.nextToken || null,
                }));
            } else {
                console.error("No items found in the response.");
                setSellers([]);
                setTotalSellers(0);
            }
        } catch (error) {
            console.error("Error in listSellers:", JSON.stringify(error, null, 2));
            alert("出品者情報の取得に失敗しました。");
        } finally {
            setOverlay(false);
        }
    };    

    const handlePasswordReset = async () => {
        if (newPassword !== confirmPassword) {
            alert("パスワードが一致しません");
            return;
        }

        // パスワードのポリシーに合致しているか確認
    const passwordPolicyRegex = /^(?=.*[a-z])(?=.*\d).{8,}$/;
    if (!passwordPolicyRegex.test(newPassword)) {
        alert("パスワードは8文字以上で、少なくとも1つの小文字と1つの数字を含む必要があります。");
        return;
    }

        setOverlay(true);
        try {
            alert("パスワードが正常にリセットされました");
            closePasswordDialog();
        } catch (error) {
            console.error("パスワードリセットエラー:", error);
            alert("パスワードリセットに失敗しました");
        } finally {
            setOverlay(false);
        }
    };

    const openPasswordDialog = (seller) => {
        setTargetSeller(seller);
        setPasswordDialog(true);
    };

    const closePasswordDialog = () => {
        setTargetSeller({});
        setNewPassword("");
        setConfirmPassword("");
        setPasswordDialog(false);
    };

    

    const checkStripeRegistration = (stripeID) => {
        return stripeID ? { text: "済", color: "green" } : { text: "未登録", color: "red" };
    };

    const handleSellersPerPageChange = async (event) => {
        const newLimit = event.target.value;
        
        setSellersPerPage(newLimit); 
        setPage(1);  // ページをリセット
        setNextTokens({ 1: null });  // ページネーションをリセット
        setCurrentPage(1);

        await fetchTotalSellers();

        setTimeout(() => {
        listSellers(1, newLimit); // 新しい件数でデータを取得
    }, 100);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        setCurrentPage(value);
        fetchData(value);

        setNextTokens(prevTokens => ({
            ...prevTokens,
            [value]: value === 1 ? null : prevTokens[value],
        }));

        if (value === 1 || nextTokens[value] !== null) {
            listSellers(value, sellersPerPage);
            
        } else {
        }
    };


    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Box p={4} width="100%" maxWidth="1200px" mx="auto">
            {overlay && (
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                </Box>
            )}
            {!overlay && (
                <>
                    <Typography variant="h4" mb={3}>
                        出品者登録済みユーザー一覧
                    </Typography>

                    {/* 1ページあたりの表示件数を選択 */}
                    <Box mb={3} mt={3} display="flex" alignItems="center" gap={2}>
                        <Typography variant="h6">表示件数：</Typography>

                            <FormControl size="small" variant="outlined">
                                <InputLabel>件数</InputLabel>
                                <Select
                                    value={sellersPerPage}
                                    onChange={handleSellersPerPageChange}
                                    label="件数"
                                >
                                    <MenuItem value={10}>10件</MenuItem>
                                    <MenuItem value={25}>25件</MenuItem>
                                    <MenuItem value={50}>50件</MenuItem>
                                    <MenuItem value={100}>100件</MenuItem>
                                </Select>
                            </FormControl>
                    </Box>

                    <TableContainer style={{ marginBottom: "20px", overflowX: "auto" }}>
                        <Table style={{ width: "100%", tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow>
                                <TableCell style={{ fontSize: "18px", width: "300px", whiteSpace: "normal" }}>氏名</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "300px", whiteSpace: "normal" }}>メールアドレス</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "200px", whiteSpace: "normal" }}>電話番号</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "300px", whiteSpace: "normal" }}>住所</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "150px", whiteSpace: "normal" }}>Stripe登録</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "200px", whiteSpace: "normal" }}>登録日時</TableCell>
                                <TableCell style={{ fontSize: "18px", width: "200px", whiteSpace: "normal" }}>パスワードリセット</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sellers.map((seller) => (
                                    <TableRow key={seller.id}>
                                        <TableCell style={{ fontSize: "18px" }}>{seller.name}</TableCell>
                                        <TableCell style={{ fontSize: "18px" }}>{seller.email}</TableCell>
                                        <TableCell style={{ fontSize: "18px" }}>{seller.phone}</TableCell>
                                        <TableCell style={{ 
                                            fontSize: "18px", 
                                            Width: "300px", 
                                            whiteSpace: "normal",
                                            }}
                                            >
                                                {seller.postal ? `〒${seller.postal} ` : ""}{seller.address}</TableCell>
                                        <TableCell style={{ fontSize: "18px", color: seller.stripeID ? "green" : "red" }}>
                                           {seller.stripeID ? "済" : "未登録"}
                                        </TableCell>
                                        <TableCell style={{ fontSize: "18px" }}>
                                            {new Date(seller.createdAt).toLocaleString()}
                                            </TableCell>
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                color="primary" 
                                                style={{
                                                    fontSize: "16px", // 文字サイズ
                                                }}
                                                onClick={() => openPasswordDialog(seller)}
                                            >
                                                リセット
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Pagination
                        count={totalPages} 
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        sx={{ my: 2 }}
                        size="large"
                    />

                    {/* 管理ページに戻るボタン */}
                    <Box
                            position="fixed"
                            left="20px"
                            bottom="20px"
                            zIndex={1000}
                        >
                        <Button
                                variant="contained"
                                color="primary"
                                href="/admin"
                                style={{
                                    fontSize: "16px",
                                    padding: "10px 20px",
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    borderRadius: "5px",
                                    textDecoration: "none",
                                }}
                            >
                                管理ページに戻る
                            </Button>
                        </Box>
                </>
            )}

            {/* Password Reset Dialog */}
            <Dialog open={passwordDialog} onClose={closePasswordDialog}>
                <DialogTitle>{targetSeller.name}のパスワードをリセットする</DialogTitle>
                <DialogContent>
                    <TextField
                        id="new-password"
                        name="newPassword"
                        label="新しいパスワード"
                        type={showPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        fullWidth
                        margin="dense"
                        autoComplete="new-password"
                        InputProps={{
                            endAdornment: (
                                <IconButton onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            ),
                        }}
                    />
                    <TextField
                        id="confirm-password"
                        name="confirmPassword"
                        label="パスワード（確認用）"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                        margin="dense"
                        autoComplete="new-password"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closePasswordDialog}>キャンセル</Button>
                    <Button color="primary" onClick={handlePasswordReset}>
                        パスワードリセット
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
        </MuiPickersUtilsProvider>
    );
};

// const mockFetchSellers = async (page, limit) => {
//     const sellers = Array.from({ length: limit }, (_, i) => ({
//         id: `seller-${page}-${i}`,
//         name: `Seller ${i + 1}`,
//         email: `seller${i + 1}@example.com`,
//         phone: "090-1234-5678",
//         postal: "123-4567",
//         address: "Tokyo, Japan",
//         stripeID: i % 2 === 0 ? `stripe-${i}` : null,
//         createdAt: new Date().toISOString(),
//     }));
// };

export default User;